// extracted by mini-css-extract-plugin
export default {"leftContainer":"Report_leftContainer__CXOm3","rightContainer":"Report_rightContainer__VWXsK","innerContainer":"Report_innerContainer__hHoNu"};